import hasCategoriesRouteUtil from 'modules/routes/utils/has-categories'

function shouldLoadCategoriesRouteUtil (route, match) {
  return (
    route.path &&
    hasCategoriesRouteUtil(match.pathname) &&
    (
      route.isInstance ||
      route.isCollection
    )
  )
}

export default shouldLoadCategoriesRouteUtil
